// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationList_pagination__G7t7Q"};